var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-text-field',{attrs:{"value":_vm.display,"prefix":"$","readonly":"","height":"24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }